export const getSearchQuery = (keys) => {
    const name = new URLSearchParams(window.location.search).get(keys);
    return name;
};